let canJoinRoomFn = () => true

export const setCanJoinRoom = fn => {
  if (fn) {
    canJoinRoomFn = fn
  }
}

export default {
  canJoinRoom: startSilent => canJoinRoomFn(startSilent)
}
